import { useEffect, useState } from "react";
import AdminLayout from "@/pages/admin/AdminLayout";
import { api, formatINR } from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
  }, []);

  const tiles = stats
    ? [
        { label: "Revenue", value: formatINR(stats.revenue), testId: "stat-revenue" },
        { label: "Paid Orders", value: stats.paid_orders, testId: "stat-paid-orders" },
        { label: "Total Orders", value: stats.total_orders, testId: "stat-total-orders" },
        { label: "Products", value: stats.total_products, testId: "stat-products" },
        { label: "Customers", value: stats.total_users, testId: "stat-customers" },
      ]
    : [];

  return (
    <AdminLayout title="Overview">
      {stats?.mock_payment_mode && (
        <div className="mb-6 border border-[#c8532e] bg-[#f3e0d8] rounded-md p-4 text-xs" data-testid="mock-payment-banner">
          <span className="uppercase tracking-[0.16em] font-semibold text-[#c8532e]">Demo Mode</span> · Payments are simulated. Data is stored in your browser for this session only.
        </div>
      )}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" data-testid="stats-grid">
        {tiles.map((t) => (
          <div key={t.label} className="card p-5" data-testid={t.testId}>
            <div className="text-xs font-semibold uppercase tracking-[0.16em] text-[#6b6b6b]">{t.label}</div>
            <div className="mt-2 font-display text-3xl font-semibold">{t.value ?? "—"}</div>
          </div>
        ))}
      </div>

      <div className="mt-8 grid md:grid-cols-3 gap-4">
        <a href="/admin/products/new" className="card p-5 hover:shadow-md transition-shadow" data-testid="quick-add-product">
          <div className="text-xs font-semibold uppercase tracking-[0.16em] text-[#c8532e]">Quick Action</div>
          <div className="mt-2 font-display text-2xl font-semibold">Add New Product →</div>
          <p className="mt-2 text-xs text-[#6b6b6b]">Photography, sizes, colors, stock.</p>
        </a>
        <a href="/admin/orders" className="card p-5 hover:shadow-md transition-shadow" data-testid="quick-view-orders">
          <div className="text-xs font-semibold uppercase tracking-[0.16em] text-[#c8532e]">Fulfillment</div>
          <div className="mt-2 font-display text-2xl font-semibold">Review Orders →</div>
          <p className="mt-2 text-xs text-[#6b6b6b]">Ship, deliver, or cancel.</p>
        </a>
        <a href="/admin/coupons" className="card p-5 hover:shadow-md transition-shadow" data-testid="quick-view-coupons">
          <div className="text-xs font-semibold uppercase tracking-[0.16em] text-[#c8532e]">Promotions</div>
          <div className="mt-2 font-display text-2xl font-semibold">Manage Coupons →</div>
          <p className="mt-2 text-xs text-[#6b6b6b]">Create % off or flat discounts.</p>
        </a>
      </div>
    </AdminLayout>
  );
}
